import { Vue } from 'vue-property-decorator';
import loader from '../../../utils/loader';

export default Vue.extend({
  inject: ['parentValidator'],
  components: {
    UploadAvatar: loader.component('UploadAvatar'),
  },
  props: {
    corporate: {
      type: Object,
      required: true,
    },
    banner: {
      type: [File, Object, String],
      default: null,
    },
    avatar: {
      type: String,
      default: '',
    },
    parentCorporate: {
      type: Array,
      default: () => [],
    },
    saleAdminList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    validForm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localCorporate: {
      get() {
        return this.corporate;
      },
      set(value) {
        this.$emit('update:corporate', value);
      },
    },
    localBanner: {
      get() {
        return this.banner;
      },
      set(value) {
        this.$emit('update:banner', value);
      },
    },
  },
  created() {
    // Use the validator injected from parent so 'errors.collect()' still works.
    this.$validator = this.parentValidator;
  },
  methods: {
    blockNonDigitKeys(event) {
      // Allow: digits 0–9, Backspace, Delete, Tab, Escape, Enter, arrow keys
      // for cursor navigation, Home/End, and Ctrl/Cmd combos for copy/paste.
      // Block: ArrowUp/ArrowDown (would increment/decrement on number inputs)
      // and any non-digit character key.
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (allowedKeys.includes(event.key)) return;
      if (event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
        return;
      }
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
});
